// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_1Wi4q","cell":"_3UVu0","imageWrapper":"_7BeGd","image":"_39WNk"};